import axios from "axios";
import { createBrowserHistory } from "history";
import { message, notification } from "antd";

const history = createBrowserHistory({ forceRefresh: true });

export const urlApi = import.meta.env.VITE_API_URL || "http://localhost:3000";

let API = axios.create({
  baseURL: urlApi,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const GLOBAL_LOADING_KEY = "global-api-loading";
let pendingRequestCount = 0;

const openGlobalLoading = () => {
  message.open({
    key: GLOBAL_LOADING_KEY,
    type: "loading",
    content: "Đang tải dữ liệu...",
    duration: 0,
  });
};

const closeGlobalLoading = () => {
  message.destroy(GLOBAL_LOADING_KEY);
};

const increasePendingRequest = () => {
  pendingRequestCount += 1;
  if (pendingRequestCount === 1) {
    openGlobalLoading();
  }
};

const decreasePendingRequest = () => {
  pendingRequestCount = Math.max(0, pendingRequestCount - 1);
  if (pendingRequestCount === 0) {
    closeGlobalLoading();
  }
};

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("assetToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    if (!config.silentLoading) {
      increasePendingRequest();
      config.__globalLoadingTracked = true;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

API.interceptors.response.use(
  (response) => {
    if (response.config.__globalLoadingTracked) {
      decreasePendingRequest();
    }

    // ✅ Nếu là download (blob/arraybuffer) thì bỏ qua logic JSON
    const rt = response.config.responseType;
    if (rt === "blob" || rt === "arraybuffer") return response;

    // ✅ Nếu response.data không phải object JSON thì cũng bỏ qua
    const data = response.data;
    if (!data || typeof data !== "object") return response;

    const { code, success, message } = data;

    // ✅ Cho phép tắt notify theo request
    const silent = response.config.silent;
    if (!silent && message) {
      if (success) notification.success({ message });
      else notification.error({ message });
    }

    if (code === "AUTHENTICATION_ERROR") {
      localStorage.setItem("assetToken", "");
      history.push("/login");
    }

    return response;
  },
  (error) => {
    if (error?.config?.__globalLoadingTracked) {
      decreasePendingRequest();
    }

    const data = error?.response?.data;
    const backendMessage =
      data && typeof data === "object" ? data.message : undefined;
    const normalizedMessage =
      backendMessage || error?.message || "Request failed";
    const silent = error?.config?.silent;

    error.message = normalizedMessage;
    error.__handledByApiInterceptor = true;

    if (!silent) {
      notification.error({ message: normalizedMessage });
    }

    if (data?.code === "AUTHENTICATION_ERROR") {
      localStorage.setItem("assetToken", "");
      history.push("/login");
    }

    return Promise.reject(error);
  },
);

export default API;
